import React from 'react';
import {
  ChatRequestModalOverlay,
  ChatRequestModalContent,
  ChatRequestModalHeader,
  ChatRequestModalTitle,
  ChatRequestModalCloseButton,
  ChatRequestModalButtons,
  ChatRequestModalButton,
} from '../../../styles/UserWorkspacePageStyles';
import {
  ModalForm,
  ModalFormInput,
  ModalFormStatus,
  ModalFormStatusMessage,
} from '../../../styles/ModalFormStyles';
import { useT } from '../../../LocaleContext';

const ChatRequestModal = ({
  isOpen,
  onClose,
  connectId,
  error,
  onConnectIdChange,
  onCreateRequest,
  onKeyDown,
}) => {
  const t = useT();

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreateRequest();
  };

  return (
    <ChatRequestModalOverlay onClick={onClose}>
      <ChatRequestModalContent onClick={(e) => e.stopPropagation()}>
        <ChatRequestModalHeader>
          <div />
          <ChatRequestModalTitle>{t('modals.createChatInvite')}</ChatRequestModalTitle>
          <ChatRequestModalCloseButton onClick={onClose}>
            ×
          </ChatRequestModalCloseButton>
        </ChatRequestModalHeader>
        <ModalForm $fullWidth onSubmit={handleSubmit}>
          <ModalFormInput
            type="text"
            placeholder={t('modals.connectId')}
            value={connectId}
            onChange={onConnectIdChange}
            $hasError={!!error}
            onKeyDown={onKeyDown}
            autoFocus
            maxLength={9}
          />
          <ModalFormStatus>
            <ModalFormStatusMessage success={false}>{error || ''}</ModalFormStatusMessage>
          </ModalFormStatus>
          <ChatRequestModalButtons>
            <ChatRequestModalButton type="button" onClick={onClose}>
              {t('common.cancel')}
            </ChatRequestModalButton>
            <ChatRequestModalButton
              type="submit"
              primary
              disabled={!connectId || connectId.length !== 9 || !!error}
            >
              {t('modals.sendInvite')}
            </ChatRequestModalButton>
          </ChatRequestModalButtons>
        </ModalForm>
      </ChatRequestModalContent>
    </ChatRequestModalOverlay>
  );
};

export default ChatRequestModal;
